import Vue from 'vue'
import App from './App.vue'
import router from './router'


import VueCoreImageUpload from 'vue-core-image-upload';

// eslint-disable-next-line no-unused-vars
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'

 // eslint-disable-next-line no-unused-vars
import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'

import '@/assets/styles/global_style.css'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
 
Vue.use(VxeUIAll)
Vue.use(VxeUITable)

Vue.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
})

Vue.config.productionTip = false;

document.title = '德彪AI小助手'

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
